export const setCookie = (name, value, seconds) => {
  seconds = seconds || 0; //seconds有值就直接赋值，没有为0
  let expires = "";
  if (seconds != 0) { //设置cookie生存时间
      let date = new Date();
      date.setTime(date.getTime() + (seconds * 1000));
      expires = "; expires=" + date.toGMTString();
  }
  document.cookie = name + "=" + escape(value) + expires + "; path=/"; //转码并赋值
}

export const getCookie = (name) => {
  let arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg))
      return unescape(arr[2]);
  else
      return null;
}

export const delCookie = (name) => {
  let exp = new Date();
  exp.setTime(exp.getTime() - 1);
  let cval = getCookie(name);
  if (cval != null)
      document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
}


// WEBPACK FOOTER //
// ./src/assets/js/cookies.js